import { SoapCallLogTable } from "@/components/soap-call-log/SoapCallLogTable";

export function SoapCallLogPage() {
  return <SoapCallLogTable />;
}
